// Keep the existing analytics property, but give the critical page load priority.
export function scheduleAnalytics() {
  if (window.location.pathname.startsWith('/admin')) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', 'G-6P61NGELRN');
  const load = () => window.setTimeout(() => {
    if (document.getElementById('site-analytics')) return;
    const script = document.createElement('script');
    script.id = 'site-analytics';
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-6P61NGELRN';
    document.head.appendChild(script);
  }, 2000);
  if (document.readyState === 'complete') load();
  else window.addEventListener('load', load, { once: true });
}
